import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../../axios";

export const validateOtpApi = createAsyncThunk(
  "user/validateOtp",
  async (otpData, { rejectWithValue }) => {
    try {
      const response = await axios.post("/users/validate-otp", otpData);
      return response.data;
    } catch (error) {
      console.error("ValidateOtp API error:", error);
      if (error.response && error.response.data) {
        return rejectWithValue(
          error.response.data.message || "Failed to validate OTP",
        );
      }
      return rejectWithValue("Failed to validate OTP");
    }
  },
);
